var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"bottom-img"},[_c('v-img',{attrs:{"src":_vm.bottomIcon ? _vm.bottomIcon.src : require('@/assets/new-ui/background-image.png'),"width":"100vw"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }